<script lang="ts">
    import {getInjector} from 'src/core';
    import type {ModalWindowResolveValues} from './types';
    import {ModalDialogService} from './modal-dialog.service';
    import {anyMatches, byIdOf, isNotEmpty, removeAll} from 'shared/utils/array-utils';
    import {onDestroy} from 'svelte';
    import {cleanup} from 'shared/utils/custom-utils';
    import {debounce} from 'lodash-es';
    import KpModalDialog from './KpModalDialog.svelte';

    const service = getInjector().getByClass(ModalDialogService);

    let activeDialogs: ModalWindowResolveValues<any>[] = [];
    let closingDialogs: ModalWindowResolveValues<any>[] = [];

    const removeClosedDialogs = () => {
        closingDialogs = [];
    };
    const deferRemovingClosedDialogs = debounce(removeClosedDialogs, 5000);

    const subscription = service.getDialog$().subscribe((dialogs) => {
        closingDialogs = [...closingDialogs, ...removeAll(activeDialogs, (activeDialog) => anyMatches(dialogs, byIdOf(activeDialog)))];
        activeDialogs = dialogs;
        if (isNotEmpty(closingDialogs)) {
            deferRemovingClosedDialogs();
        }
    });

    onDestroy(() => {
        cleanup(subscription);
    });

    $: allDialogs = [...activeDialogs, ...closingDialogs];
    $: openDialogIndex = activeDialogs.length - 1;
</script>

{#each allDialogs as dialog, index (dialog.id)}
    <KpModalDialog id={dialog.id} size={dialog.settings?.size} open={index === openDialogIndex}>
        <svelte:component this={dialog.component} modalWindowActions={dialog.modalWindowActions} model={dialog.model}/>
    </KpModalDialog>
{/each}
